import Login from './src/main'
export default {
  install(Vue, props) {
    Vue.prototype.$Login = options => {
      Login(options, props)
    }
  }
}
